module.exports = __webpack_public_path__ + "img/share.439daa4e.svg";